// This is show or hide the mobile version of the primary menu.
document.querySelector('button[aria-controls=mobile-menu]').addEventListener('click', function () {
    document.querySelector('#mobile-menu > div').classList.toggle('active');
    this.classList.toggle('active');
});
document.addEventListener('DOMContentLoaded', function () {
    var nav = document.getElementById('main-nav');

    // Check if the current page is the "Contact" page
    if (window.location.pathname === '/contact/') {
        nav.classList.remove('bg-rk-light-gray');
        nav.classList.add('bg-[#3D443F]');
    } else {
        nav.classList.remove('bg-[#3D443F]');
        nav.classList.add('bg-rk-light-gray');
    }
});
